<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M8.4744 0H3.52397C3.04429 0.00153307 2.65583 0.389993 2.6543 0.869671V11.2806C2.6543 12.0123 3.38739 12.3677 3.9602 11.4549L5.99919 8.20473L8.03818 11.4549C8.61099 12.3677 9.34408 12.0109 9.34408 11.2806V0.869671C9.34254 0.389993 8.95408 0.00153307 8.4744 0Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconTags"
}
</script>

<style scoped>

</style>